import { BiSearch } from "react-icons/bi";
import { Input } from "../Input";
import classes from "./SearchInput.module.css";

function SearchInput({
  value,
  setter,
  placeholder = "Search",
  customStyle,
  inputStyle,
  backgroundColor,
  iconColor = "var(--main-color)",
  onClick,
  variant = "primary",
}) {
  return (
    <Input
      setter={setter}
      value={value}
      customStyle={{
        width: "220px",
        // border: "none",
        ...customStyle,
      }}
      variant={variant}
      searchInput={classes.searchInput}
      placeholder={placeholder}
      leftIcon={
        <span
          style={{
            borderRadius: "50%",
          }}
          onClick={() => onClick && onClick()}
        >
          <BiSearch
            size={18}
            color={"#ccc"}
            style={{
              marginTop: "0px",
              marginRight: "0px",
              cursor: "pointer",
            }}
          />
        </span>
      }
      onEnter={onClick}
    />
  );
}

export default SearchInput;
